import styled from 'styled-components'
import { tokens, primitives } from '../../../assets/tokens'
import { safeDarken } from '../../../utils/color'

const { color } = tokens

// material-table pinta el pie dentro de un TableFooter con display: grid; sin display
// block y ancho completo la celda se encoge a su contenido y el pie se descoloca.
export const Cell = styled.td`
  && {
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 8px 4px;
    border: none;
    background: transparent;
  }
`

// Tres columnas: hueco | páginas (centradas) | selector y rango (a la derecha)
export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  min-height: 40px;
  font-family: ${tokens.typography.fontFamily.primary};
`

// Fondo gris neutro (el mismo de la cabecera de la tabla); la página activa va en el color del cliente
export const Pager = styled.div`
  grid-column: 2;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  background-color: ${color.background.light};
`

const resetButton = `
  border: none;
  outline: none;
  padding: 0;
  font: inherit;
  background: transparent;
`

export const PageBox = styled.button`
  ${resetButton}
  min-width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${props => (props.active ? 'default' : 'pointer')};
  font-size: 14px;
  font-weight: 500;
  color: ${props => (props.active ? props.theme.textPrimary : primitives.neutral[800])};
  background-color: ${props => (props.active ? props.theme.primary : 'transparent')};
  transition: background-color 0.15s ease;

  :hover {
    background-color: ${props => (props.active ? safeDarken(props.theme.primary) : primitives.neutral[200])};
  }
`

export const ArrowBox = styled.button`
  ${resetButton}
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => (props.disabled ? primitives.neutral[400] : primitives.neutral[800])};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`

export const Right = styled.div`
  grid-column: 3;
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${primitives.neutral[400]};

  .rows-per-page {
    font-size: 14px;
    color: ${primitives.neutral[400]};

    /* Selector compacto sin borde: no usa los 40 px de los Select del tema y el chevron va
       centrado en vertical junto al texto */
    .MuiSelect-select {
      height: auto;
      line-height: 20px;
      padding: 4px 22px 4px 4px;
      background: transparent;
      border: none;
    }

    .MuiSelect-icon {
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      color: ${primitives.neutral[400]};
    }

    .MuiSelect-iconOpen {
      transform: translateY(-50%) rotate(180deg);
    }
  }
`

export const Range = styled.span`
  white-space: nowrap;
`
